import { render, staticRenderFns } from "./clueDetails.vue?vue&type=template&id=760a2d1e"
import script from "./clueDetails.vue?vue&type=script&lang=js"
export * from "./clueDetails.vue?vue&type=script&lang=js"
import style0 from "./clueDetails.vue?vue&type=style&index=0&id=760a2d1e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports